import { createAsyncThunk } from '@reduxjs/toolkit';
import { CreditScoreHistoryResponse, ReportsApi } from 'api/ReportsApi';

export const createGetCreditScoreHistoryThunk = (api: ReportsApi) =>
  createAsyncThunk<CreditScoreHistoryResponse, string>(
    'creditScoreHistory/getCreditScoreHistory',
    async (applicationId, thunkApi) => {
      try {
        return await api.getCreditScoreHistory(applicationId);
      } catch (error: unknown) {
        return thunkApi.rejectWithValue(error);
      }
    },
  );
